import "./CreateEditRestrictions.css";

import Pages from "./Pages";
import Readers from "./Readers";
import AllowedRestrictedReaders from "./AllowedRestrictedReaders";
import MoveReaders from "./MoveReaders";
import { useState, useRef, useEffect } from "react";
import Alert from "../../../Controls/Alerts/Alerts";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../../StateManagement/actions";
import ModalPopUp from "../../../Controls/ModalPopUp/ModalPopUp";
const readersDetails = {
  id: null,
  fileName: "",
  category: "",
  readers: [],
  pages: [],
};

export default function CreateEditRestrictions({
  docPages,
  fileName,
  documentId,
  readers,
  totalReaders,
  editRestrictionDetails,
  onCancel,
  onSave,
  prevSelectedPages,
  pagesToBeDisabledAnotherRestrictions,
  isEdit,
  addReaderToField,
  ReceipientLists,
  addRule,
  enableOptionsBasedOnLevelOne,
  isFromManage,
  onValidateRestriction,
  pageLevelAccessRequests
}) {
  console.log(editRestrictionDetails);
  console.log(fileName);
  const selectedReadersRef = useRef([]);
  const selectedPagesRef = useRef([]);
  const previousPagesRef = useRef([]);
  const pagesBeforeValidationRef = useRef([]);
  const selectedCategoryReadersRef = useRef([]);
  const isRequestAccess = useRef([]);
  const totalReadersRef = useRef(totalReaders.length > 0 ? totalReaders : []);

  const [readersSelected, setreadersSelected] = useState(
    editRestrictionDetails ? editRestrictionDetails : readersDetails
  );

  const [addReader, setAddReader] = useState(false);
  const [readersList, setReadersList] = useState(readers);
  //const [addedReaderList, setAddedReaderList] = useState(readers);
  const [selectedReadersList, setSelectedReadersList] = useState([]);
  //const [category, setCategory] = useState("Select Category");
  const categoryRef = useRef("Select Category");

  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const [selectedOption, setSelectedOption] = useState(
    enableOptionsBasedOnLevelOne ? "No Readers" : ""
  );
  const [isShowAddReader, setIsShowAddReader] = useState(false);
  const [selectedOptionObj, setSelectedOptionObj] = useState({});
  const onCancelHandler = () => {
    onCancel();
  };
  const ruleNickName = useRef("");
  const warningModal = useRef();
  const buildRestrictionData = (
    selectedReaders,
    selectedPages,
    allowAccessRequest
  ) => ({
    id: isEdit ? editRestrictionDetails.id : Math.random().toFixed(3),
    documentId,
    fileName,
    category: selectedOption,
    readers: [...selectedReaders],
    pages: [...selectedPages],
    isEdits: isEdit,
    ruleNickname: ruleNickName.current.value,
    allowAccessRequest
  });

  useEffect(() => {
    if (editRestrictionDetails?.pages) {
      previousPagesRef.current = [...editRestrictionDetails.pages];
    }
  }, [editRestrictionDetails]);

  const onSaveHandler = () => {
    const pageNumbers = Array.from(
      { length: docPages },
      (_, index) => index + 1
    );
    if (selectedOption == "") {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectRestrictionType);
      setAlertType("warning");
      return;
    }
    let selectedPages = [];
    const pages = selectedPagesRef.current.getSelection();
    selectedPages = [...pages.sort((a, b) => a - b)];
    pagesBeforeValidationRef.current =
      editRestrictionDetails?.pages?.length
        ? [...editRestrictionDetails.pages]
        : Array.isArray(prevSelectedPages?.current)
          ? [...prevSelectedPages.current]
          : Array.isArray(prevSelectedPages)
            ? [...prevSelectedPages]
            : [];
    const allowAccessRequest = isRequestAccess.current && isRequestAccess.current.checked ? true : false;
    // if (isEdit) {
    //   const selectedInputs = selectedPagesRef.current
    //     .map((element, i) =>
    //       element && element.checked && !element.disabled ? i : null
    //     )
    //     .filter((i) => i !== null);
    //   selectedPages = pageNumbers.filter((num) => selectedInputs.includes(num));
    // }
    //  else {
    // const selectedInputs = selectedPagesRef.current
    //   .map((element, i) =>
    //     element && element.checked && !element.disabled ? i : null
    //   )
    //   .filter((i) => i !== null);
    //selectedPages = pageNumbers.filter((num) => selectedInputs.includes(num));
    //}
    let selectedReaders = [];
    try {
      selectedReaders = selectedReadersRef?.current?.getSelectedReaders();
      console.log(selectedReaders);
    } catch (err) {
      console.error("Error getting readers:", err);
    }
    if (ReceipientLists) {
      const bannedReader = ReceipientLists.find(
        (element) =>
          element.status === "Banned" &&
          selectedReaders.includes(element.email)
      );
      if (bannedReader) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_RulesCannotcreateEdit +
          " " +
          bannedReader.email
        );
        setAlertType("warning");
        return;
      }
    }
    if (selectedPages.length === 0) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectReadersToImpose
      );
      setAlertType("warning");
      return;
    }
    // if (categoryRef.current === "Select Category") {
    //   setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectCategory);
    //   setAlertType("warning");
    //   return;
    // }
    // selectedReadersRef.current = selectedReadersRef.current.filter(
    //   (r) => r !== null && r.checked === true
    // );
    // const selectedReaders = selectedReadersRef.current
    //   .filter((element) => {
    //     if (selectedOptionObj.noReaders) {
    //       return true;
    //     } else if (selectedOptionObj.selectedReaders) {
    //       return element.checked;
    //     } else {
    //       return element.checked;
    //     }
    //   })
    //   .map((element) => element.id);

    if (selectedOption != "No Readers" && selectedReaders.length === 0) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtlestOneReader
      );
      setAlertType("warning");
      return;
    }

    // const selectedReadersTotal = [
    //   ...new Set([...selectedReaders, ...selectedReadersList]),
    // ];

    const restrictionData = buildRestrictionData(selectedReaders, selectedPages, allowAccessRequest);
    const validation = onValidateRestriction?.(restrictionData);
    const readerList = totalReadersRef.current.filter((reader) => [...readersList, ...selectedReadersList].includes(reader));
    if (validation?.shouldShowPopup) {
      warningModal.current.open(
        validation.message,
        () => {

          previousPagesRef.current = [...restrictionData.pages];

          onSave(restrictionData, readerList);
        },
        () => {
          selectedPagesRef.current.resetSelection(
            previousPagesRef.current,
            pagesToBeDisabledAnotherRestrictions
          );
        }
      );
      return;
    }

    onSave(restrictionData, readerList);
  };

  const onToggle = (addedReaders) => {
    setAddReader(false);
    setReadersList(addedReaders);
    totalReadersRef.current = [
      ...new Set([...totalReadersRef.current, ...addedReaders]),
    ];
    addReaderToField(addedReaders);
    return;
  };

  useEffect(() => {
    selectedPagesRef.current.doSelectionandDisable(
      prevSelectedPages,
      pagesToBeDisabledAnotherRestrictions
    );
    selectedReadersRef.current.checkSelectedReadersAndCategory(
      !isEdit
        ? readersList
        : editRestrictionDetails
          ? editRestrictionDetails.readers
          : [],
      editRestrictionDetails ? editRestrictionDetails.category : ""
    );
  }, [addRule]);

  const onAddReaderHandler = (isToAddReader = true) => {
    setAddReader(isToAddReader);
  };
  // useEffect(() => {
  //   setTimeout(() => {
  //     setAlertMsg("");
  //     setAlertType("");
  //   }, 5000);
  // }, [alertType]);
  useEffect(() => {
    if (editRestrictionDetails) {
      const selectedReadersTotal = totalReaders.filter((reader) =>
        editRestrictionDetails.readers.includes(reader)
      );
      console.log(editRestrictionDetails);
      setSelectedReadersList(selectedReadersTotal);
      console.log(selectedReadersRef.current);
      ruleNickName.current.value = editRestrictionDetails.ruleNickname;

    }
  }, [editRestrictionDetails]);
  const showAddReaderHandler = (isShow, option) => {
    setIsShowAddReader(isShow);
    setSelectedOption(option);
  };

  const onAllowRequestAccessChange = (e) => {
    if (!isEdit || !isFromManage || !enableOptionsBasedOnLevelOne || e.target.checked) return;
    const existingRule = editRestrictionDetails;
    if (!existingRule) return;
    const hasAccessRequests = pageLevelAccessRequests?.some(
      request => request.documentId === documentId && request.requestedPages?.some(page => existingRule.pages?.includes(page))
    );
    if (hasAccessRequests) {
      const message = selectedLanguage.LstLanguageCodes.UI_EditAllowAccessRequest;
      // e.target.checked = true;
      warningModal.current.open(message,
        () => {
          isRequestAccess.current.checked = false;
        },
        () => {
          isRequestAccess.current.checked = true;
        }
      );
    }
  };

  return (
    <>
      <Alert alertType={alertType} alertMsg={alertMsg} setAlertMsg={setAlertMsg} setAlertType={setAlertType}></Alert>
      <ModalPopUp ref={warningModal}></ModalPopUp>

      <div
        className="child-popup"
      // id="myModal"
      //style={{ display: "block", backgroundColor: "#8080801c" }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-customelg "
        >
          <div
            className={`modal-content ${(isShowAddReader == true || addRule == true) ? "w-158" : "w-580"
              }`} style={{ minHeight: "550px" }}>
            <div className="modal-header">
              <h5
                className="d-flex align-items-center text-danger fw-bold mb-0"
                id="staticBackdropLabel">
                {selectedLanguage.LstLanguageCodes.UI_CreateEditRestrictions}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onCancelHandler}
                style={{ fontSize: "0.85rem" }}></button>

            </div>
            <div className="noteTxtPageResPopup">
              <span className="txtNote">{selectedLanguage.LstLanguageCodes.UI_Note}
              </span>: <span >{selectedLanguage.LstLanguageCodes.UI_IfNochangesAremadeToRestrictions}</span>
            </div>
            <div className="modal-body createEdit">
              <Pages
                docPages={docPages}
                ref={selectedPagesRef}
                selectedPages={prevSelectedPages}
                pagesToBeDisabledAnotherRestrictions={
                  pagesToBeDisabledAnotherRestrictions
                }
                isEdit={isEdit}
              />
              <div className="overflow-hidden d-flex" >
                {/* <div className="d-flex mb-3 gx-0 "> */}

                <Readers
                  readers={readersList}
                  ref={selectedReadersRef}
                  isAddToReaders={addReader}
                  onAddReader={onAddReaderHandler}
                  documentID={documentId == undefined ? 0 : documentId}
                  onToggle={onToggle}
                  onShowAddReader={showAddReaderHandler}
                  selectReaders={selectedReadersList}
                  selectedCategory={
                    editRestrictionDetails
                      ? editRestrictionDetails.category
                      : ""
                  }
                  isEdits={
                    editRestrictionDetails != null &&
                    editRestrictionDetails.isEdits
                  }
                  enableOptionsBasedOnLevelOne={enableOptionsBasedOnLevelOne}
                  isFromManage={isFromManage}
                />
                {/* </div> */}
              </div>

            </div>
            <div className="checkbox">
              <label className="allow-access">
                <input
                  className="form-check-input"
                  type="checkbox" ref={isRequestAccess}
                  defaultChecked={editRestrictionDetails?.allowAccessRequest || false}
                  disabled={isFromManage && isEdit && enableOptionsBasedOnLevelOne}
                  onChange={onAllowRequestAccessChange}
                />
                <span className="cr">
                  <i className="cr-icon material-icons">check</i>
                </span>
              </label>
              <label className="mb-0 request-access">
                {selectedLanguage.LstLanguageCodes.UI_AllowRequestAccess}
              </label>
            </div>
            <div className="modal-footer border-0 pb-3 justify-content-between">
              <div className="nickName">
                <label htmlFor="nickName">{selectedLanguage.LstLanguageCodes.UI_RuleNickname}: </label>
                <input className="custom-inputBorder" style={{ padding: '0.45rem 0.75rem' }}
                  type="text"
                  id="nickName"
                  placeholder="Optional"
                  ref={ruleNickName}
                  maxLength={50}
                />
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-danger px-2 w-140p truncate"
                  data-bs-dismiss="modal"
                  onClick={onCancelHandler}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-2 ms-3 w-140p truncate"
                  data-bs-dismiss="modal"
                  onClick={onSaveHandler}
                  title={!isEdit ? selectedLanguage.LstLanguageCodes.UI_AddRule : selectedLanguage.LstLanguageCodes.UI_UpdateRule}>
                  {!isEdit ? selectedLanguage.LstLanguageCodes.UI_AddRule : selectedLanguage.LstLanguageCodes.UI_UpdateRule}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
